var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(
      _vm.browserSize.md === true ||
      _vm.browserSize.lg === true ||
      _vm.browserSize.xl === true
    )?_c('TopNavbar'):_vm._e(),_c('Navbar'),_c('v-main',{attrs:{"transition":"slide-x-transition"}},[_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }